import { extensions } from '@yola/ws-sdk';
import constants from '../constants/common';

// Checks whether an element is an html embed element (`ws-html-embed`).
// Covers both the html embed block and the html embed widget, which share the same tag.
function isHtmlEmbedElement(element) {
  if (!element) return false;

  const { querySelector } = extensions.accessors.getExtensionSettings(constants.slug);

  return element.matches(querySelector);
}

export default isHtmlEmbedElement;
